import { NgClass } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IConfig } from '../../../interfaces/config.interface';

interface NavItem {
  label: string;
  route: string;
  expanded?: boolean;
  children?: NavItem[];
}

@Component({
  selector: 'app-sidebar',
  imports: [NgClass, RouterModule],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class Sidebar {
  config = input<IConfig | undefined>();

  mainNavs = computed<NavItem[]>(() => {
    const showRepairer =
      !!this.config() &&
      this.config()!.partner.filter((e) => Boolean(e.value)).length > 1;
    const segmentationChildren: NavItem[] = [
      ...(showRepairer
        ? [
            {
              label: 'Réparateur',
              route: '/segmentation/reparateur',
            },
          ]
        : []),
      {
        label: 'Diagnostic',
        route: '/segmentation/diagnostic',
      },
      {
        label: 'En Centre / SAD',
        route: '/segmentation/intervention',
      },
    ];

    return [
      {
        label: 'Accueil',
        route: '/',
      },
      {
        label: 'Performance',
        route: '/performance',
      },
      {
        label: 'Segmentation',
        route: '/segmentation',
        expanded: false,
        children: segmentationChildren,
      },
    ];
  });

  readonly bottomNavs: NavItem[] = [
    {
      label: 'Données brutes',
      route: '/donnees-brutes',
    },
  ];

  toggleSubMenu(nav: NavItem): void {
    if (nav.children && nav.children.length > 0) {
      nav.expanded = !nav.expanded;
    }
  }

  isActiveRoute(route: string): boolean {
    return window.location.pathname === route;
  }
}
